import {
    Button,
    CloseIcon,
    Dialog,
    Divider,
    Dropdown,
    ExcelIcon,
    Flex,
    InputLabel,
    Text,
} from "@fluentui/react-northstar";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { MIN_DATE } from "../../../../utils/dateValidation";
import { DateRangeType } from "@fluentui/react-calendar-compat";
import styled from "styled-components";
import useLogicDialogExportHoursWorked from "../../hooks/useLogicDialogExportHoursWorked";

const DialogExportHoursWorked = ({ listEmployeesDepartments = [] }) => {
    const { translations, dialog, functions, form } =
        useLogicDialogExportHoursWorked();

    return (
        <Dialog
            open={dialog.open}
            header={translations.t("society.timesheet.dialog.header")}
            content={
                <Flex column gap="gap.medium">
                    <Flex>
                        <p>
                            {translations.t(
                                "society.timesheet.dialog.sub_header"
                            )}
                        </p>
                    </Flex>
                    <div>
                        <Divider />
                    </div>
                    <Flex column>
                        <InputLabel
                            content={translations.t(
                                "society.timesheet.dialog.form.date_picker.label"
                            )}
                        />
                        <Flex gap="gap.medium" vAlign="center">
                            <Text
                                content={translations.t(
                                    "society.timesheet.dialog.form.from"
                                )}
                            />
                            <SDatePicker
                                calendar={{
                                    dateRangeType: DateRangeType.Month,
                                    isDayPickerVisible: false,
                                    showGoToToday: false,
                                }}
                                inputMode="text"
                                strings={translations.localizedStrings}
                                placeholder={translations.t(
                                    "society.timesheet.dialog.form.date_picker.placeholder"
                                )}
                                formatDate={functions.onFormatDate}
                                onSelectDate={functions.onSelectDate}
                                value={form.from.value}
                                minDate={MIN_DATE}
                                maxDate={form.to.value}
                            />
                            <Text
                                content={translations.t(
                                    "society.timesheet.dialog.form.to"
                                )}
                            />
                            <SDatePicker
                                calendar={{
                                    dateRangeType: DateRangeType.Month,
                                    isDayPickerVisible: false,
                                    showGoToToday: false,
                                }}
                                inputMode="text"
                                strings={translations.localizedStrings}
                                placeholder={translations.t(
                                    "society.timesheet.dialog.form.date_picker.placeholder"
                                )}
                                formatDate={functions.onFormatDate}
                                onSelectDate={functions.onSelectDateTo}
                                value={form.to.value}
                                minDate={form.from.value || MIN_DATE}
                            />
                        </Flex>
                    </Flex>
                    <Flex column>
                        <InputLabel
                            content={translations.t(
                                "society.timesheet.dialog.form.emplyees_departments.label"
                            )}
                        />
                        <Dropdown
                            placeholder={translations.t(
                                "society.timesheet.dialog.form.emplyees_departments.placeholder"
                            )}
                            items={listEmployeesDepartments}
                            onChange={functions.onChangeUsersDepartments}
                            positionFixed
                            multiple
                            search
                        />
                    </Flex>
                </Flex>
            }
            trigger={
                <Flex fill hAlign="end" onClick={dialog.openDialog}>
                    <Button
                        secondary
                        flat
                        content={translations.t("society.timesheet.export")}
                        icon={<ExcelIcon />}
                    />
                </Flex>
            }
            confirmButton={{
                content: translations.t(
                    "society.timesheet.dialog.buttons.confirm"
                ),
                flat: true,
                disabled: !form.isValid,
                loading: form.isDownloading,
                onClick: functions.downloadExcel,
            }}
            cancelButton={{
                content: translations.t("common.cancel", {
                    ns: "translation",
                }),
                flat: true,
                onClick: functions.beforeCloseDialog,
            }}
            headerAction={{
                icon: <CloseIcon />,
                onClick: functions.beforeCloseDialog,
            }}
        />
    );
};

export default DialogExportHoursWorked;

const SDatePicker = styled(DatePicker)`
    background-color: rgb(245, 245, 245);
    color: rgb(36, 36, 36);
    padding-block: 0.3571rem;
    padding-inline: 0.8571rem;
    border-radius: 4px;
    width: 50%;
`;
